import { useEffect, useState } from 'react';
import { Stack, Group, Text, Badge, Paper, Loader, Center, Alert } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { authedFetch } from './session';

const STATUS_COLORS = {
    new: 'orange', received: 'blue', planned: 'violet',
    in_progress: 'cyan', completed: 'green', cancelled: 'gray',
};
const STATUS_LABELS = {
    new: 'Nieuw', received: 'Ontvangen', planned: 'Ingepland',
    in_progress: 'In behandeling', completed: 'Afgerond', cancelled: 'Geannuleerd',
};
const URGENCY_COLORS = { low: 'gray', normal: 'blue', high: 'orange', critical: 'red' };

export default function ServiceRequestList() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const r = await authedFetch('/support/my/service-requests');
                setItems(r.items || []);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    if (loading) return <Center p="md"><Loader size="sm" /></Center>;
    if (error) return <Alert color="red" icon={<IconAlertCircle size={16} />}>{error}</Alert>;
    if (items.length === 0) {
        return <Text size="sm" c="dimmed">U heeft nog geen openstaande service-aanvragen.</Text>;
    }

    return (
        <Stack gap="xs">
            {items.map((sr) => (
                <Paper key={sr.id} withBorder p="sm">
                    <Group justify="space-between" align="flex-start" wrap="nowrap">
                        <div style={{ minWidth: 0 }}>
                            <Group gap={6}>
                                <Text fw={500} size="sm">{sr.title}</Text>
                                <Badge size="xs" color={URGENCY_COLORS[sr.urgency] || 'gray'} variant="light">
                                    {sr.urgency}
                                </Badge>
                            </Group>
                            <Text size="xs" c="dimmed" mt={2}>
                                {sr.license_plate || `#${sr.ambulance_id}`}
                                {sr.base_vehicle_make ? ` · ${sr.base_vehicle_make} ${sr.base_vehicle_model || ''}` : ''}
                            </Text>
                            <Text size="xs" c="dimmed">
                                Ingediend: {(sr.submitted_at || sr.created_at)?.slice(0, 16)}
                            </Text>
                        </div>
                        <Badge color={STATUS_COLORS[sr.status] || 'gray'} variant="light">
                            {STATUS_LABELS[sr.status] || sr.status}
                        </Badge>
                    </Group>
                </Paper>
            ))}
        </Stack>
    );
}
